export default {
  K: "#00639a",
  R: "#00639a",
  H: "#00639a",
};
